import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import LandingPageNav from "../../Components/LandingPageNav/index.jsx";
import Splash from '../../Components/Utils/Splash';
import LPageFooter from "../../Components/LandingPageFooter/index.jsx";

import { selectAuthData } from '../../redux/selectors/auth';

import iphone_frame from '../../assets/ev_plug_here_screens.webp';
import ev_logo from '../../assets/ev_logo_white.png';
import iphone_first_section from '../../assets/iphone_first_section.webp';
import edit_organization_image from '../../assets/edit_organizations_image.webp';
import floating_phones from '../../assets/floating_phones.webp';
import reports_graph from '../../assets/reports_graph.svg';
import monitoring from '../../assets/monitoring_img.svg';

import '../../Styles/style.scss';
import './style.scss';
import ScrollToTopButton from "../../Components/ScrollToTopButton/index.jsx";


const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#3f50b5',
      dark: '#002884',
      contrastText: '#fff'
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000'
    }
  }
});

const Welcome = () => {
  const { t } = useTranslation();
  const { user: { email: userEmail = '' } = {} } = useSelector(selectAuthData);
  const navigate = useNavigate();

  useEffect(() => {
    if (userEmail) {
      //auto-login user if session exists
      navigate('/dashboard');
    }
  }, [userEmail, navigate]);

    return (
    <>
        <LandingPageNav/>
        <div className={'welcome'}>
            <div className={'welcome__background'} id={'backToTop'}>
              <div className={'welcome__header_section flex-container'}>
                  <div className={'welcome__header_section__text_container'}>
                      <img src={ev_logo} alt="" className={'float_animation'}/>
                        <p>{t('landing_page_header_description')}</p>
                        <Splash isNavBar={false} />
                  </div>
                  <div className={'welcome__header_section__image_container'}>
                    <img src={iphone_frame} alt='iphone_img' />
                  </div>
              </div>
            </div>
          <div className={'welcome__first_section section_padding background flex-container'} id={'our_platform'}>
              <div className={'welcome__first_section__text_container'}>
                  <h2>{t('our_platform')}</h2>
                  <p>{t('landing_page_header_multi_language')}</p>
                  <p>{t('landing_page_header_key_modules')}</p>
                  <a className={'button__charlie'} href={'mailto:contact@evplughere.com;'}>{t('contact_us')}</a>

              </div>
              <div className={'welcome__first_section__image_container'}>
                  <img src={iphone_first_section} alt=""/>
              </div>
          </div>
          <div className={'welcome__second_section section_padding flex-container'} id={'manage'}>
              <div className={'welcome__second_section__image_container'}>
                  <img src={edit_organization_image} alt=""/>
              </div>
              <div className={'welcome__second_section__text_container text_styling'}>
                  <h2>{t('manage')}</h2>
                  <p>{t('landing_page_second_section_modules')}</p>
                  <p>{t('landing_page_second_section_roadmap')}</p>
              </div>
          </div>
            <div className={'welcome__third_section background section_padding flex-container'} id={'control'}>
                <div className={'welcome__third_section__text_container text_styling'}>
                    <h2>{t('control')}</h2>
                    <p>{t('landing_page_third_section_user_interact')}</p>
                    <p><b>Using the RFID card:</b></p>
                    <p className={'subtext'}>{t('landing_page_third_section_rfid_card')}</p>
                    <p><b>{t('landing_page_third_section_web_app')}</b></p>
                    <p className={'subtext'}>{t('landing_page_third_section_registered_user')}</p>
                    <p><b>{t('landing_page_third_section_pay')}</b></p>
                    <p className={'subtext'}>{t('landing_page_third_section_default_payment')}</p>
                </div>
                <div className={'welcome__third_section__image_container'}>
                    <img src={floating_phones} alt=""/>
                </div>
            </div>
            <div className={'welcome__fourth_section section_padding flex-container'} id={'report'}>
                <div className={'welcome__fourth_section__image_container'}>
                    <img src={reports_graph} alt=""/>
                </div>
                <div className={'welcome__fourth_section__text_container text_styling'}>
                    <h2>{t('reports')}</h2>
                    <p>{t('landing_page_fourth_section_charging_history')}</p>
                    <p>{t('landing_page_fourth_section_admins')}</p>
                </div>
            </div>
            <div className={'welcome__fifth_section section_padding background flex-container'} id={'monitoring'}>
                <div className={'welcome__fifth_section__text_container text_styling'}>
                    <h2>{t('monitoring')}</h2>
                    <p>{t('landing_page_fifth_section_OCPP')}</p>
                    <p>{t('landing_page_fifth_section_key_modules')}</p>
                </div>
                <div className={'welcome__fifth_section__image_container'}>
                    <img src={monitoring} alt=""/>
                </div>
            </div>
            <ScrollToTopButton/>
            <LPageFooter/>
        </div>

    </>
  );
};

export default Welcome;
